import { render } from "./BoxRegion.vue?vue&type=template&id=ed20f82c&scoped=true"
import script from "./BoxRegion.vue?vue&type=script&lang=js"
export * from "./BoxRegion.vue?vue&type=script&lang=js"

import "./BoxRegion.vue?vue&type=style&index=0&id=ed20f82c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed20f82c"],['__file',"src/containers/widget/configs/BoxRegion.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ed20f82c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ed20f82c', __exports__)) {
    api.reload('ed20f82c', __exports__)
  }
  
  module.hot.accept("./BoxRegion.vue?vue&type=template&id=ed20f82c&scoped=true", () => {
    api.rerender('ed20f82c', render)
  })

}


export default __exports__